// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  sbotd: {
    name: 'special-buy-page',
    componentName: 'SpecialBuyPage',
    chunk: () => import(
      /* webpackChunkName: "special-buy-page" */
      './pages/SpecialBuyPage'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SpecialBuyPage.js')).SpecialBuyPage
        : currentRouteName === 'special-buy-page'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SpecialBuyPage })));
    },
    path: '/:context?/SpecialBuy/SpecialBuyOfTheDay',
    channel: null,
    varnish: true
  },
  dailyDeals: {
    name: 'special-buy-page',
    componentName: 'SpecialBuyPage',
    chunk: () => import(
      './pages/SpecialBuyPage'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SpecialBuyPage.js')).SpecialBuyPage
        : currentRouteName === 'special-buy-page'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SpecialBuyPage })));
    },
    path: '/:context?/daily-deals',
    channel: null,
    varnish: true
  },
  pro: {
    name: 'special-buy-page',
    componentName: 'SpecialBuyPage',
    chunk: () => import(
      /* webpackChunkName: "special-buy-page" */
      './pages/SpecialBuyPage'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SpecialBuyPage.js')).SpecialBuyPage
        : currentRouteName === 'special-buy-page'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SpecialBuyPage })));
    },
    path: '/:context?/SpecialBuy/ProSpecialBuyOfTheWeek',
    channel: null,
    varnish: true
  }
});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
